import React, { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Hero = () => {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "10%"]);

  return (
    <section ref={ref} className="relative overflow-hidden" data-testid="hero-section"
             style={{ backgroundColor: "var(--ink)" }}>
      <div className="relative w-full">
        <motion.img
          src="/assets/img/fb-cover-v2.png"
          alt=""
          className="w-full h-auto block hero-bg"
          style={{ y: reduce ? 0 : bgY }}
          aria-hidden="true"
        />

        {/* Label logo as a decal on the window glass (top-left skyline). Positions are % of the image so it tracks every viewport. */}
        <motion.img
          src="/assets/img/logo.png"
          alt="Heart N Soul Records"
          initial={reduce ? false : { opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.9, ease: EASE }}
          className="absolute pointer-events-none select-none"
          style={{
            left: "1.6%", top: "4.5%", width: "12.5%",
            filter: "drop-shadow(0 2px 6px rgba(0,0,0,.65)) drop-shadow(0 0 14px rgba(200,155,60,.18))",
            opacity: 0.94,
          }}
          data-testid="hero-window-logo"
        />
      </div>

      <motion.div
        initial={reduce ? false : { opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.9, duration: 0.7, ease: EASE }}
        className="mx-auto max-w-[1360px] px-5 sm:px-8 pt-3 pb-6 sm:pt-4 sm:pb-8 text-center"
        data-testid="hero-slogan"
      >
        <p className="font-script foil-text" style={{ fontSize: "clamp(1.55rem, 5.8vw, 5.6rem)", lineHeight: 1.05, whiteSpace: "nowrap" }}>
          Music with Heart, Stories with Soul.
        </p>
      </motion.div>
    </section>
  );
};
